export default __webpack_public_path__ + "static/media/1.4af5d38a.png";